import React from "react";

import { cx } from "~/tools/class-variance";

export const SettingsSectionGrid: React.FC<React.ComponentProps<"div">> = ({ className, ...props }) => (
	<div {...props} className={cx("grid gap-x-4 gap-y-2", className)} />
);
